import { useEffect, useState } from "react";

import EnableMfaTotp from "@/EnableMfaTotp";
import { useDialog } from "@datanac/datanac-mui-toolkit/dist/hooks";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { Button, Dialog, DialogActions, DialogContent, Grid, Stack, Typography } from "@mui/material";
import { fetchMFAPreference, getCurrentUser } from "aws-amplify/auth";
import { MarketingIcon } from "components/Icons/Icons";
import WorkspaceHeader from "components/Workspaces/WorkspaceHeader";
import { NO_MFA, SMS_MFA, TOTP_MFA } from "core/AuthHelper";
import { useSnackbar } from "notistack";

import { ThemeToggle } from "./core/ThemeToggle";

export default function UserPreferencesWorkspace() {
  const { enqueueSnackbar } = useSnackbar();

  const [currentUser, setCurrentUser] = useState(null);
  const [preferredMFA, setPreferredMFA] = useState(null);

  useEffect(() => {
    loadCurrentUser();
    handleFetchMFAPreference();
  }, []);

  const handleFetchMFAPreference = async () => {
    try {
      const { preferred } = await fetchMFAPreference();
      setPreferredMFA(preferred);
    } catch (error) {
      const errorMessage = "Error loading preffered MFA";
      enqueueSnackbar(errorMessage, { variant: "error" });
      console.error(errorMessage, error);
    }
  };
  const loadCurrentUser = async () => {
    try {
      let curUser = await getCurrentUser();
      setCurrentUser(curUser);
    } catch (error) {
      console.error("Error loading current user:", error);
    }
  };

  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();
  const handleOnClick = () => {
    confirmDialogActions.confirm({
      title: "TOTP Configuration",
      prompt: "Do you wish to change your one-time password token?",
      promptDetail: null,
      callback: () => {
        setEditingItem(true);
      },
    });
  };

  const [editingItem, setEditingItem] = useState(null);

  const closeDialog = () => {
    setEditingItem(false);
  };

  const handleTotpOnChange = () => {
    enqueueSnackbar("One-Time Password Token changed successfully", { variant: "info" });
    loadCurrentUser();
    closeDialog();
  };

  const getMFAStatus = () => {
    if (preferredMFA === TOTP_MFA) {
      return "One-Time Password";
    } else if (preferredMFA === SMS_MFA) {
      return "SMS";
    } else if (preferredMFA === NO_MFA) {
      return "Not enabled";
    } else {
      return "MFA status unknown";
    }
  };

  return (
    <>
      <WorkspaceHeader
        title={currentUser?.username}
        category={{
          title: "Change One-Time Password Token",
          icon: <MarketingIcon />,
        }}
      />

      <Grid container spacing={2}>
        <Grid item xs={12} lg={2}>
          <Typography variant="h1">MFA Status</Typography>

          {preferredMFA !== null && (
            <Typography variant="body2" component="h2">
              {getMFAStatus()}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} lg={10}>
          <Stack direction="row" spacing={2}>
            <Button variant="contained" onClick={handleOnClick}>
              Change One-Time Password Token
            </Button>
          </Stack>
        </Grid>
        <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
          <Typography variant="h1">Appearance</Typography>
          <ThemeToggle />
        </Grid>
      </Grid>

      <Dialog open={Boolean(editingItem != null) && editingItem} className="changeMFADialog">
        <DialogContent>
          <EnableMfaTotp
            handleLogoutClick={""}
            type={"userProfile"}
            onClose={closeDialog}
            onChange={handleTotpOnChange}
          />
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ mr: 1 }}
            variant="outlined"
            onClick={() => {
              setEditingItem(false);
            }}
          >
            <CloseOutlined sx={{ mr: 1 }} />
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {confirmDialogComponent}
    </>
  );
}
